export enum LinkStyle {
  primary = 'primary',
  secondary = 'secondary',
  custom = 'custom',
}
